import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSave, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BModal } from "bootstrap-vue";
import { ref } from "vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SaveChangesModal',
    props: {
        showModal: { type: Boolean, default: false },
        navUrl: null
    },
    emits: ["on-proceed", "update:nav-url", "update:show-modal"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faSave, faTimes, faTrash);
        const busy = ref(false);
        const title = localize("You have unsaved changes. Do you want to save them before proceeding?");
        const body = localize("Click 'Save' to save your changes and proceed, 'Don't Save' to discard them and proceed, or 'Cancel' to return to the editor.");
        const buttonTitles = {
            cancel: localize("Do not run proceed and return to editor"),
            dontSave: localize("Discard changes and proceed"),
            save: localize("Save changes and proceed"),
        };
        function closeModal() {
            emit("update:show-modal", false);
            emit("update:nav-url", "");
        }
        function dontSave() {
            busy.value = true;
            emit("on-proceed", props.navUrl, false, true, true);
        }
        function saveChanges() {
            busy.value = true;
            closeModal();
            emit("on-proceed", props.navUrl, true, false, true);
        }
        return { __sfc: true, props, busy, emit, title, body, buttonTitles, closeModal, dontSave, saveChanges, faSave, faTimes, faTrash, FontAwesomeIcon, BButton, BModal, localize };
    }
});
